export const fieldSupportsOperator = (schema, fieldName, operator) => {
    const queryOperators = schema.fields[fieldName]?.queryOperators;
    return !queryOperators || queryOperators.includes(operator);
};
//# sourceMappingURL=fieldSupportsOperator.js.map